module.exports = __webpack_public_path__ + "img/index-steps.6081bbd4.png";